module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('strong', {
    staticClass: "calibre1"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0005#a4OIQ01018b6e42b47406d96d6286df4255d8e"
    }
  }, [_vm._v("Part One: 1946")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0006#a5N3C01018b6e42b47406d96d6286df4255d8e"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#a6LJU01018b6e42b47406d96d6286df4255d8e"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#a7K4G01018b6e42b47406d96d6286df4255d8e"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0009#a8IL201018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#a9H5K01018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: 1947")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#AFM60-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#BE6O0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#CCNA0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#DB7S0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0015#E9OE0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0016#F8900-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: 1948-1950")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0017#G6PI0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0018#H5A40-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0019#I3QM0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0020#J2B80-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0021#K0RQ0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0022#KVCC0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0023#LTSU0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four: 1951")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0024#MSDG0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0025#NQU20-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0026#OPEK0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0027#PNV60-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Five: 1952")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0028#QMFO0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINETEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0029#RL0A0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0030#SJGS0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Six: 1952-1953")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0031#TI1E0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0032#UGI00-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0033#VF2I0-1018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0034#a10DJ401018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Seven: 1953")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0035#a11C3M01018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0036#a12AK801018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0037#a1394Q01018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWENTY SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter1"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0038#a147LC01018b6e42b47406d96d6286df4255d8e",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46fdfad8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0004.vue
// module id = 72
// module chunks = 0